import React from 'react';
import TvPackage from "./tvPackage";
import TranslationService from "../../service/TranslationService";
import {
    ADDITIONAL_PACKAGES,
    CHOOSE_FREE_PACKAGE_1_NEW,
    CHOOSE_FREE_PACKAGE_2_NEW,
    CHOOSE_FREE_PACKAGE_2_NEW_FREE,
    CHOOSE_FREE_PACKAGE_3_NEW,
    CHOOSE_FREE_PACKAGE_3_NEW_HBO_PREMIUM_LITE,
    CHOOSE_FREE_PACKAGE_3_NEW_HBO_PREMIUM,
    CHOOSE_FREE_PACKAGE_3_NEW_0_FREE_PACKAGES,
    PRICE_INCLUDE_VAT
} from "../../language-content/keys";
import {useTvChannelsContext} from "../../context/TvChannelsContext";
import Loader from "../loader";

function AdditionalTvPackages(props) {
    const {
        tvPackages, dvbtTvPackages, isAdditionalPackageSelectable,
        fetchingTvPackages
    } = useTvChannelsContext()

    const selectOrRemovePackage = (p) => {
        const remove = props.selectedAdditionalTvPackages.includes(p.id);
        props.updateQueryParams('additionalPackage', p.id, remove);
    };

    if (!props.tvPackages || props.tvPackages.length === 0)
        return null;

    const freePackages = tvPackages && tvPackages['FREE'] && tvPackages['FREE'].length !== 0

    function displayAdditionalPackagesBoxHeader() {
        let hboHtml = null;
        const hasHboPremiumLitePackageName = props.tvPackages.find(tp => tp.nameEN == 'HBO Premium Lite');
        const hasHboLitePackageName = props.tvPackages.find(tp => tp.nameEN == 'HBO Premium');

        if(hasHboPremiumLitePackageName){
            hboHtml = TranslationService.translate(CHOOSE_FREE_PACKAGE_3_NEW_HBO_PREMIUM_LITE, props.lang);
        }else if(hasHboLitePackageName){
            hboHtml = TranslationService.translate(CHOOSE_FREE_PACKAGE_3_NEW_HBO_PREMIUM, props.lang);
        }
        // if (freePackages > 0) {
            return (
                <div className="row">
                    <div className="col-12 text-center mb-5 text-white">
                        <h4 className="sans-light mb-3 mt-5 text-uppercase">
                            {/*{TranslationService.translate(CHOOSE_FREE_PACKAGE_1_NEW, props.lang)}&nbsp;*/}
                            {/*<strong className="sans-bold">{props.freePackageCount}&nbsp;</strong>*/}
                            {/*{TranslationService.translate(CHOOSE_FREE_PACKAGE_2_NEW, props.lang)}*/}
                            {/*<strong className="sans-bold">*/}
                            {/*    {TranslationService.translate(CHOOSE_FREE_PACKAGE_2_NEW_FREE, props.lang)}*/}
                            {/*</strong>*/}
                            {props.tariffModelContent?.title}
                        </h4>
                        <h6 className="sans-regular mb-3">
                            {/*{TranslationService.translate(CHOOSE_FREE_PACKAGE_3_NEW, props.lang)}*/}
                            {/*<br/>*/}
                            {/*{hboHtml}*/}
                            {props.tariffModelContent?.topContent}
                        </h6>
                    </div>
                </div>
            )
        // } else {
        //     return (
        //         <div className="row">
        //             <div className="col-12 text-center mb-5 text-white">
        //                 <h5 className="sans-regular mb-3">{TranslationService.translate(CHOOSE_FREE_PACKAGE_3_NEW_0_FREE_PACKAGES, props.lang)}</h5>
        //             </div>
        //         </div>
        //     )
        // }
    }

    function displayAdditionalPackagesBoxFooter() {
        return (
            <div className="row">
                <div className="col-12 text-center d-block mt-4">
                    <small className="text-white">{props.tariffModelContent?.bottomContent}</small>
                    {/*<small className="text-white">{TranslationService.translate(PRICE_INCLUDE_VAT, props.lang)}</small>*/}
                </div>
            </div>
        )
    }

    return (
        <section id="additional-packages" className={`bg-gray-90 py-5 ${!freePackages ? 'no-packages' : ''}`}>
            <div className="container">
                {/* <div className="row">
                    <div className="col-12 text-center">
                        <h4 className="serif-regular mb-5 text-white">
                            {TranslationService.translate(ADDITIONAL_PACKAGES, props.lang)}
                        </h4>
                    </div>
                </div> */}
                {fetchingTvPackages ?
                    <Loader/>
                    :
                    <>
                        {displayAdditionalPackagesBoxHeader()}

                        <div className="row">
                            <div className="col-12 col-md-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
                                <div
                                    className="row row-cols-2 row-cols-md-4 d-flex flex-fill justify-content-center">

                                    {props.tvPackages.map(tp => {
                                        return (<TvPackage package={tp} wrapperClassName={"additional package-wrapper "}
                                                           selectDisplayTvPackage={(p) => props.selectDisplayTvPackage(p)}
                                                           selectPackage={(p) => selectOrRemovePackage(p)}
                                                           additional
                                                           selected={props.selectedAdditionalTvPackages.includes(tp.id)}
                                                           selectable={isAdditionalPackageSelectable(tp)}
                                                           lang={props.lang}/>)
                                    })}

                                </div>

                            </div>
                        </div>

                        {displayAdditionalPackagesBoxFooter()}
                    </>
                }
            </div>

        </section>

    );
};

export default AdditionalTvPackages;